import { render, staticRenderFns } from "./MenuManagement.vue?vue&type=template&id=525bb849&scoped=true&"
import script from "./MenuManagement.vue?vue&type=script&lang=js&"
export * from "./MenuManagement.vue?vue&type=script&lang=js&"
import style0 from "./MenuManagement.vue?vue&type=style&index=0&id=525bb849&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525bb849",
  null
  
)

export default component.exports